/**
 * Payout Entity Definition
 */
import { PayoutRelationSchema } from "../schemas/relations";
import { BillingDataEntityDef } from "./billing-data.entity";
import { defineEntity } from "./core";
import { getLazyUserEntityDef } from "./lazy-refs";
export const PayoutEntityDef = defineEntity({
    name: "payout",
    schema: PayoutRelationSchema,
    relations: {
        pm_issuerBillingData: { type: "one", entity: () => BillingDataEntityDef },
        pm_recipientBillingData: { type: "one", entity: () => BillingDataEntityDef },
        pm_user: { type: "one", entity: getLazyUserEntityDef },
    },
});
